import styled, { keyframes } from "styled-components";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Maggie",
      session: "Maternity Session",
      text: `I can’t recommend Rainbow Trout Reverie enough!! Lexi is an absolute genius behind the lens! She really goes above and beyond finding the best locations and props for her shoots. Typically I am not very comfortable in front of the lens, but the way Lexi holds space for you and guides you throughout the photo shoot will make you feel like you can conquer anything. She really pours her heart and soul into every shoot and you can feel it. Her adventurous spirit and intuitive creativity will not disappoint. I had the honor for Lexi to capture my maternity photos and she made me feel the most beautiful I felt throughout my entire pregnancy. I will definitely be a life long customer because her talent is unmatched!`,
    },
    {
      name: "The Gower Family",
      session: "Lifestyle Session",
      text: `Lexi was extremely responsive and quickly confirmed her availability. She scoped out a perfect golden hour location in RMNP and ensured everything was flawless. She noticed every little detail, from stray hairs to keys in pockets. Lexi captured so many natural moments we didn’t even realize she was taking — and delivered a sneak peek within a day! If the opportunity arises, we’ll absolutely book her again. 10/10 recommend!`,
    },
    {
      name: "The Clough Family",
      session: "Lifestyle Session",
      text: `Lexi is such an amazing photographer. We had our family of 5 (ages 7, 5, and 3), and she made it fun for everyone! We ended up with some of our favorite family photos ever taken. She makes you feel so comfortable, such a great vibe, and she made sure to not miss any shots we asked for. We’ll be using her again and again!`,
    },
    {
      name: "Kk",
      session: "Couples & Creative Portraits",
      text: `She has such a creative mind and brings her visions to life! She’s so welcoming and makes you feel comfortable throughout the shoot. I’ve done family, couple, and creative sessions with her — loved every one!`,
    },
    {
      name: "Stefanie",
      session: "Lifestyle Session",
      text: `Lexi is an amazing photographer and one of the kindest people. Even in the midst of chaos, she captured beautiful photos of our family with such patience and care. 🥰`,
    },
    {
      name: "Hannah & David",
      session: "Elopement",
      text: `I’m eloping 10.23.25, and so far this girl is AMAZING! Attentive and passionate about her work. She reached out personally — not pushy, just genuine. She’s helping us plan bouquet details, timelines, and even backup locations for bad weather. If you’re considering her for family or wedding photography, DO IT!`,
    },
    {
      name: "Desteni",
      session: "Lifestyle Session",
      text: `Lexi is upbeat and positive and got so many different shots! We did a couples shoot with our two dogs, and she didn’t hesitate to help pose and redirect them. She even scoped the location ahead for safety and timed it perfectly for golden hour. Thank you Lexi!!!`,
    },
    {
      name: "The Riddle Family",
      session: "Lifestyle Session",
      text: `Lexi provided the best photoshoot experience hands down. She was incredibly sweet and bubbly and made us so comfortable. Her eye for detail captured our family perfectly — pure magic!`,
    },
  ];

  return (
    <TestimonialsSection>
      <BackgroundAura />
      <FloatingAccent style={{ top: "12%", left: "6%" }} />
      <FloatingAccent
        style={{ bottom: "8%", right: "10%", animationDelay: "-2s" }}
      />

      <Content>
        <Header>
          <Eyebrow>Client Kindness</Eyebrow>
          <Title>Stories from the people who let me in.</Title>
          <Subtitle>
            A handful of favorite love notes from couples, families, and fellow
            adventurers who trusted me to craft their heirloom moments.
          </Subtitle>
        </Header>

        <TestimonialsGrid>
          {testimonials.map((t, i) => (
            <Card key={i}>
              <QuoteMark>“</QuoteMark>
              <Quote>{t.text}</Quote>

              <Meta>
                <Name>{t.name}</Name>
                <Session>{t.session}</Session>
              </Meta>
            </Card>
          ))}
        </TestimonialsGrid>
      </Content>
    </TestimonialsSection>
  );
}

// 🎨 Styled Components
const floaty = keyframes`
  0% { transform: translateY(0px) translateX(0px); opacity: 0.65; }
  50% { transform: translateY(-10px) translateX(6px); opacity: 1; }
  100% { transform: translateY(0px) translateX(0px); opacity: 0.65; }
`;

const TestimonialsSection = styled.section`
  position: relative;
  background: radial-gradient(
      circle at 15% 20%,
      rgba(255, 255, 255, 0.14),
      transparent 35%
    ),
    radial-gradient(
      circle at 80% 10%,
      rgba(255, 255, 255, 0.18),
      transparent 30%
    ),
    linear-gradient(135deg, #ada98d 0%, #8f8b75 50%, #a7a488 100%);
  padding: 120px 20px 140px;
  color: #2f2c24;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

const Content = styled.div`
  width: min(1040px, 92vw);
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BackgroundAura = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(
      600px circle at 20% 35%,
      rgba(255, 255, 255, 0.16),
      transparent 40%
    ),
    radial-gradient(
      500px circle at 75% 60%,
      rgba(255, 255, 255, 0.12),
      transparent 45%
    );
  mix-blend-mode: screen;
  opacity: 0.8;
`;

const Header = styled.header`
  text-align: center;
  max-width: 100%;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
`;

const Eyebrow = styled.p`
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-size: 0.75rem;
  color: #f3f1e5;
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-size: clamp(2rem, 3vw, 2.8rem);
  color: #fefcf7;
  margin-bottom: 18px;
`;

const Subtitle = styled.p`
  color: #f6f3e9;
  opacity: 0.92;
  line-height: 1.6;
`;

const TestimonialsGrid = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  width: 100%;
`;

const Card = styled.article`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.9),
    rgba(250, 248, 241, 0.9)
  );
  border-radius: 0px;
  border: 3px solid rgba(69, 71, 47, 0.45);
  padding: 28px 26px 30px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(4px);
  position: relative;
  overflow: hidden;
  transition: transform 0.35s ease, box-shadow 0.35s ease;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
      circle at 30% 20%,
      rgba(173, 169, 141, 0.2),
      transparent 40%
    );
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.35s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 50px rgba(0, 0, 0, 0.12);

    &::after {
      opacity: 1;
    }
  }
`;

const QuoteMark = styled.span`
  font-size: 2.5rem;
  color: #ada98d;
  display: block;
  margin-bottom: 10px;
`;

const Quote = styled.p`
  font-size: 1rem;
  line-height: 1.7;
  color: #2f2c24;
`;

const Meta = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 22px;
  gap: 12px;
  flex-wrap: wrap;
`;

const Name = styled.p`
  font-weight: 700;
  font-size: 1rem;
  color: #3b372d;
`;

const Session = styled.span`
  font-size: 0.9rem;
  background: rgba(173, 169, 141, 0.18);
  color: #3b372d;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(173, 169, 141, 0.35);
`;

const FloatingAccent = styled.div`
  position: absolute;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.22),
    rgba(255, 255, 255, 0)
  );
  filter: blur(1px);
  animation: ${floaty} 8s ease-in-out infinite;
  opacity: 0.75;
`;
